import type { MediaModel } from '../../data-layer/media/types';
import type { PostModel } from '../../data-layer/posts/types';
import type { PostPersistenceUI } from '../../ui/posts/types';

export const toPostPersistenceUI = (model: PostModel): PostPersistenceUI => {
    const site = model.clickouts.find((c) => c.target === 'button');
    const media = model.content
        .map((c) => {
            if (c.type === 'image') {
                const origImg = c.media.find((m) => m.url.includes('/orig'));

                if (!origImg) {
                    return undefined;
                }

                return {
                    type: 'image',
                    id: c.id,
                    url: origImg.url,
                    width: origImg.width,
                    height: origImg.height,
                };
            }

            if (c.type === 'video') {
                const [video] = c.media;

                if (!video) {
                    return undefined;
                }

                return {
                    type: 'video',
                    id: c.id,
                    url: video.url,
                    width: video.width,
                    height: video.height,
                    firstFrameUrl: video.firstFrameUrl,
                };
            }

            return undefined;
        })
        .filter(Boolean) as MediaModel[];

    return {
        id: model.id,
        businessId: model.business ? model.business.id : undefined,
        source: model.source,
        text: model.text,
        media,
        site: site?.urlDisplay ?? site?.url,
        status: model.status,
        products: model.products,
    };
};
